import "primeicons/primeicons.css";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect,useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import Select from "react-select";
import "assets/css/grid_table.css";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";
import moment from "moment";

const UpdateLPN  = () => {
  let emptyRow = {
   organization_id: "",
   delivery_name: "",
   delivery_id : "",
   shipping_method : "",
   customer_name : "",
   ship_to_customer : "",
   ship_to_full_address : "",
   delivery_pick_status: ""
  };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] =useState(true);
  const [fetchCustomers, setFetchCustomers] = useState(true);
  const [customerName, setCustomerName] = useState([]);
  const [customerNameId, setCustomerNameId] = useState({label: "", value: null});
  const [deliveryNumber, setDeliveryNumber]=useState("");
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [delDetails, setDelDetails] = useState({});
  const [message, setMessage] = useState("");
  const [loadingRowId, setLoadingId] = useState(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([])
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);

  useEffect(() => {
        const fetchCustomers = async () => {
          setFetchCustomers(true);
          try {
            let res = await getDataApi("/api/customerUCC/customerUCCLabel/listCustomers");
            if (res) {
              let successFlag = res.data[0];
              console.log("List Customer Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.customer_name,
                  value: item.customer_id
                }))
                setCustomerName(options)
                setFetchCustomers(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchCustomers(false);
          }
        };
        fetchCustomers();
      }, []);

  const fetchRows = async () => {
      const p_param = {
        p_customer_id: customerNameId.value,
        p_delivery_number: deliveryNumber,
     };
     console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/customerUCC/updateLPNProcess/selDeliveries");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(true);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
     finally {
      fetchStarted.current = false;
    }
    };

    useLayoutEffect(() => {
           if(!fetchStarted.current){
          fetchStarted.current=true
          fetchRows();
           }
        }, [customerNameId]);
 
    const handleLoadData = async () => {
      const p_param = {
        p_customer_id: customerNameId.value,
        p_delivery_number: deliveryNumber,
     };
     console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/customerUCC/updateLPNProcess/selDeliveries");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(true);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };

    const handleUpdateLPN = async (rowData, index) => {
          const p_param = {
            p_delivery_id: rowData.delivery_id,
         };
         console.log(p_param);
          try {
            setLoadingIndex(index);
            const response = await loadApi(p_param,"/api/customerUCC/updateLPNProcess/updateLPN");
            console.log("Fetched Update LPN Data:", response.data);
            console.log(response.data[0]);
            if (response.data.length > 0) {
              let successFlag = response.data[0];
              if (successFlag === "Y") {
                console.log("success=Y for update LPN");
                setMessage(response.data[1]);
                setLoadingIndex(null);
                setShowProductDialog(true);
              } else {
                //setRows(null);
                setMessage("");
                setLoadingIndex(null);
                const errorInfo = response.data[1];
                // Set the error message and display the dialog
                setErrorMessage(errorInfo);
                setErrorDialogVisible(true);
              }
            } else {
              //setRows(null);
              setMessage("");
              setLoadingIndex(null);
            }
    
            //setRows(response.data);
          } catch (error) {
            console.error("Error fetching data:", error);
            setLoadingIndex(null);
        }
        };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const shipDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.ship_date);
  };

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="row d-flex justify-content-center m-5">
        <div className="col-auto">
          <div className="card shadow-sm border-primary">
            <div className="card-header bg-primary text-white">
              <h2 className="mb-0">
              Update LPN for EDI ASN
              </h2>
            </div>
            <div className="card-body text-center">
              <h3>
                <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                The page is loading...
              </h3>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

const getLoadedHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="header-container">
      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
      Update LPN for EDI ASN
          {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
        </h2>
      </div>
    </React.Fragment>
  );
}
const getErrrorMsgContents = () => {
  return (
    <React.Fragment>
      <div class="row mt-5 justify-content-md-center">
        <div class="col-3">
          <div class="card border-secondary">
            <div class="card-header bg-dark text-white">
            Update LPN for EDI ASN table is Unavailable
            </div>
            <div class="card-body card-body-error rounded-bottom">
              <ul>
                {loadingErrors.map((error) => (
                  <li>
                    error
                  </li>
                ))}

              </ul>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const handleCustomerNameId = (selectedOption) => {
    if(selectedOption == null) {
      setCustomerNameId({label: "", value: null});
    } else {
    setCustomerNameId(selectedOption);
    }
}

const getSearchControls = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);

const getCustomerName = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Customer Name</label>
         <Select
            // className="form-select"
            id="customerNameId"
            name="customerNameId"
            onChange={handleCustomerNameId}
            options={customerName}
            value={customerNameId}
            placeholder="Select Machine Group"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
  );

const getDeliveryNumberControl = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">Delivery Number</label>
          <InputText 
          type="text"
          id = "DeliveryNumber"
          name="DeliveryNumber" 
          onChange={(e) => setDeliveryNumber(e.target.value)}
          placeholder="Enter Delivery Number"
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);
 

const getGoButtonControl = () => (
  <React.Fragment>
      {/* <div className="col-auto d-flex align-items-center justify-content-center ps-2 pt-4 mt-2 pe-0"> */}
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
  </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
     <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const UpdLpnForEDITemplate = (rowData, options) => {
    const isload = loadingIndex === options.rowIndex;
    return (
      <React.Fragment>
        <Button
          icon={isload ? "pi pi-spin pi-spinner" : "pi pi-pencil"}
          loading={isload}
          disabled={isload}
          className="p-button-rounded p-button-primary"
          onClick={() => handleUpdateLPN(rowData, options.rowIndex)}
          tooltip="Upd LPN for EDI"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const fetchDelDetails = async (delivery_id) => {
        setIsLoading1(true);
        setLoadingId(delivery_id);
        const p_param = {
          p_delivery_id: delivery_id,
        };
        console.log(p_param);
        try {
          const response = await loadApi(
            p_param,
            "/api/customerUCC/updateLPNProcess/selDelDetails"
          );
          console.log("Fetched Order Lines:", response.data);
    
          if (response.data.length > 0) {
            const successFlag = response.data[0];
            if (successFlag === "Y") {
              setDelDetails((prevDelDetails) => ({
                ...prevDelDetails,
                [delivery_id]: response.data[1],
              }));
              setIsLoading1(false);
            } else {
              setDelDetails((prevDelDetails) => ({
                ...prevDelDetails,
                [delivery_id]: [],
              }));
            }
          } else {
            setDelDetails((prevDelDetails) => ({ ...prevDelDetails, [delivery_id]: [] }));
            setIsLoading1(false);
          }
        } catch (error) {
          console.error("Error fetching delDetails:", error);
        } finally {
          setIsLoading1(false);
          setLoadingId(null);
        }
      };
    
      useEffect(() => {
        const prevExpanded = prevExpanRef.current;
      const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
      newlyExpanded.forEach((delivery_id) => {
          if(delivery_id) {
            fetchDelDetails(delivery_id);
          }
        });
        prevExpanRef.current = expandedRowId;
      }, [expandedRowId])
     

   const drillDownTemplate = (rowData) => {
        const isExpanded = expandedRowId.includes(rowData.delivery_id);
    
        return (
          <Button
            icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
            className={`p-button-rounded p-button-sm ${
              isExpanded ? "p-button-danger" : "p-button-primary"
            }`}
            onClick={() => toggleRowExpansion(rowData.delivery_id)}
            tooltip="Detail"
            tooltipOptions={{ position: "bottom" }}
            style={{ fontSize: "1rem" }}
          />
        );
      };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

  const rowExpansionTemplate = (data) => {
        const delDetailsData = delDetails[data.delivery_id] || [];
        const exportCSV1 = () => {
          dt1.current.exportCSV();
        };
    
        return (
          <div className="p-3">
            {loadingRowId == data.delivery_id && (<h6>The data is loading...</h6>)}
            {loadingRowId != data.delivery_id && (<>
            <div className="header-container">
              <div className="header-container p-1">
                <style>
                  {`
                    input::placeholder {
                      font-size: 17px;
                    }
                  `}
                </style>
                <span className="p-input-icon-right w-full md:w-auto">
                  <InputText
                    type="search"
                    onInput={(e) => setGlobalFilter1(e.target.value)}
                    placeholder="Search..."
                    className="w-full lg:w-auto text-sm p-3"
                    style={{ fontSize: "17px" }}
                  />
                </span>
                <Button
                  icon="pi pi-upload"
                  className="p-button-primary p-button-rounded"
                  onClick={exportCSV1}
                  tooltip="Export"
                  tooltipOptions={{ position: "bottom" }}
                  style={{ marginLeft: "20px", marginBottom: "10px" }}
                />
                <span style={{marginLeft: "20px"}}>
                  <b>No. of Rows :</b> {delDetailsData.length}
                </span>
              </div>
            </div>
            <DataTable
              ref={dt1}
              value={delDetailsData}
              responsiveLayout="scroll"
              globalFilter={globalFilter1}
            >

              <Column field="delivery_id" header="Delivery#"  bodyStyle={{ textAlign:'right' }} sortable></Column>
              <Column field="order_number" header="Order Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
              <Column field="line_number" header="Line Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
              <Column field="item_number" header="Item Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
              <Column field="lpn_number" header="LPN Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
              <Column
                field="wdd_attribute11"
                header="BOL Num"
                bodyStyle={{ textAlign:'right' }}
                sortable
              ></Column>
              <Column
                field="ship_date"
                header="Ship Date"
                body={shipDateBodyTemplate}
                sortable
              ></Column>
              <Column
                field="requested_quantity"
                header="Req Qty"
                bodyStyle={{ textAlign:'right' }}
                sortable
              ></Column>
              <Column
                field="shipped_quantity"
                header="Shipped Qty"
                bodyStyle={{ textAlign:'right' }}
                sortable
              ></Column>
              <Column
                field="customer_number"
                header="Customer Num"
                bodyStyle={{ textAlign:'right' }}
                sortable
              ></Column>
              <Column
                field="customer_name"
                header="Customer Name"
                sortable
              ></Column>
            </DataTable>
            </>
            )}
          </div>
        );
      };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {fetchCustomers ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!fetchCustomers && (
      <div className="row">
      <div className="col">
        <div className="row justify-content-center">
          {getSearchControls()}
          {getCustomerName()}
          {getDeliveryNumberControl()} 
          {getGoButtonControl()}
        </div>
      {!wasDataFetchingSuccessful && (
      <div className="card my-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">DXP Poll Data Files</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="delivery_name"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          expandedRows={expandedRowId.map((delivery_id) =>
                rows.find((rows) => rows.delivery_id === delivery_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.delivery_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((delivery_id) => delivery_id !== rowId)
                    : [...prev, rowId]
                );
              }}
              rowExpansionTemplate={rowExpansionTemplate}
              responsiveLayout="scroll"
        >
         
          <Column body={drillDownTemplate} style={{ width: "3rem", textAlign: "center" }}/>
          <Column body={UpdLpnForEDITemplate} header="Upd LPN For EDI" exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="delivery_name" header="Delivery#" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="shipping_method" header="Ship Method" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="customer_name" header="Customer Name" style={{whiteSpace: 'nowrap' }} sortable></Column>
          <Column field="ship_to_customer" header="Ship to Customer" style={{whiteSpace: 'nowrap' }} sortable></Column>
          <Column field="ship_to_full_address" header="Ship to Address" style={{whiteSpace: 'nowrap' }} sortable></Column>
          <Column field="delivery_pick_status" header="Pick Status" style={{whiteSpace: 'nowrap' }} sortable ></Column>
        </DataTable>
      </div>
      )}
      </div>
      </div>
      )}
      <Dialog visible={showproductDialog} style={{ width: '600px' }} header="Update LPN for EDI ASN" modal className="p-fluid" onHide={hideDialog} footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }>
                
        <p>{message}</p>

      </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            </div>
    </div>
  );
};

export default UpdateLPN;